import React from 'react'
import type { PopperProps as MuiPopperProps } from '@material-ui/core/Popper'
import MuiPopper from '@material-ui/core/Popper'

export type PopperProps = MuiPopperProps

function Popper(props: PopperProps) {
  return <MuiPopper {...props} />
}

export default Popper
